import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { avatarService } from '@/services/avatar';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useAvatarBundleEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const { executeAction, excuteAndNotify, confirmAndRemove } = useCrudActions();

    const model = reactive({
        id: route.params.bundleId,
        name: '',
        gender: 0,
        status: null,
        canDelete: false
    });

    const validations = {
        name: { required },
        gender: { required },
        status: { required }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = executeAction({
        request: () => avatarService.bundle.get(model.id),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_AVATAR.BUNDLE.INDEX })
    });

    const actions = {
        update: excuteAndNotify({
            validator: v$,
            request: () => avatarService.bundle.update(model.id, model.name, model.gender, model.status),
            onSuccess: () => router.push({ name: ROUTE_NAME_AVATAR.BUNDLE.INDEX })
        }),
        remove: confirmAndRemove({
            request: () => avatarService.bundle.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_AVATAR.BUNDLE.INDEX })
        })
    };

    return { model, v$, fetch, actions };
}
